module.exports = __webpack_public_path__ + "assets/img/0b19f2073687e10d65cee22595485424.png";